// extracted by mini-css-extract-plugin
export default {"sidebar":"Sidebar_sidebar__223Ug","button_group":"Sidebar_button_group__znElp","title":"Sidebar_title__WlLq6"};